import React from "react";

// Lightweight animated film grain layered over the whole app.
// The ::before overlay from index.css handles the still noise;
// here we add a faint moving layer for life.
const FilmGrain = () => {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[90] mix-blend-overlay opacity-[0.06] grain-anim"
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='300' height='300'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.95' numOctaves='2' stitchTiles='stitch'/><feColorMatrix type='saturate' values='0'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
      }}
    />
  );
};

export default FilmGrain;
